/* eslint-disable import/prefer-default-export */

const DEVICE = {
  ICOR: 'iCOR',
};

export { DEVICE };
